import { ComponentConfig } from "@measured/puck";
import {
  SectionHeaderComponent,
  SectionHeaderComponentProps,
} from "@kunduz/feature-landing-pages";
import {
  cmsIcons,
  defaultComponentAlignment,
  defaultComponentAlignmentFields,
  defaultComponentSize,
  defaultComponentSizeFields,
} from "../../utils";

export interface SectionHeaderProps extends SectionHeaderComponentProps {}

const SectionHeader = (props: SectionHeaderProps) => {
  return <SectionHeaderComponent {...props} />;
};

export const PuckSectionHeader: ComponentConfig<SectionHeaderProps> = {
  label: "Section Header",
  fields: {
    badgeIcon: { type: "select", label: "Badge Icon", options: cmsIcons },
    badgeTitle: { type: "text", label: "Badge Title" },
    badgeTitleTheme: {
      type: "select",
      label: "Badge Title Theme",
      options: [
        { value: "blue_gradient", label: "Blue Gradient" },
        { value: "green_gradient", label: "Green Gradient" },
      ],
    },
    title: { type: "text", label: "Title" },
    description: { type: "text", label: "Description" },
    buttons: {
      type: "array",
      label: "Buttons",
      arrayFields: {
        label: { type: "text", label: "Label" },
        url: { type: "text", label: "URL" },
        image: { type: "text", label: "Image" },
        type: {
          type: "select",
          label: "Type",
          options: [
            { label: "Primary", value: "primary" },
            { label: "Secondary", value: "secondary" },
          ],
        },
        target: { type: "text", label: "Target" },
      },
      min: 0,
      max: 2,
      defaultItemProps: {
        label: "Button",
        url: "#",
        image: "",
        type: "secondary",
        target: "_self",
      },
    },
    options: {
      type: "object",
      label: "Options",
      objectFields: {
        ...(defaultComponentAlignmentFields as any),
        ...(defaultComponentSizeFields as any),
      },
    },
  },
  defaultProps: {
    badgeIcon: "counseling",
    badgeTitle: "Badge Title",
    badgeTitleTheme: "blue_gradient",
    title: "Section Header Title",
    description: "Section Header Description",
    buttons: [
      {
        label: "Button 1",
        url: "#",
        image: "",
        type: "primary",
        target: "_self",
      },
      {
        label: "Button 2",
        url: "#",
        image: "",
        type: "secondary",
        target: "_self",
      },
    ],
    options: {
      ...defaultComponentSize,
      ...defaultComponentAlignment,
    },
  },
  render: (props) => <SectionHeader {...props} />,
};
